import { render, staticRenderFns } from "./partData.vue?vue&type=template&id=2c5602ea&scoped=true"
import script from "./partData.vue?vue&type=script&lang=js"
export * from "./partData.vue?vue&type=script&lang=js"
import style0 from "./partData.vue?vue&type=style&index=0&id=2c5602ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5602ea",
  null
  
)

export default component.exports